import { CampusLocation } from "@packages/types";
import { useMutation } from "@tanstack/react-query";

import { GetApi, PaymentApi } from "~/api";
import { useApplicationFees } from "./reference-data";

/**
 * Returns the application fee for an application at the specified campus location.
 */
export function useApplicationFee(
  campusLocation?: CampusLocation,
  residencySubStatus?: string,
): number | undefined {
  const feeAmounts = useApplicationFees();
  const fee = feeAmounts.data?.find((fee) => fee.campusLocation === campusLocation);
  if (!residencySubStatus || !fee?.residencySubStatus) return fee?.defaultAmount;
  if (residencySubStatus in fee.residencySubStatus)
    return fee.residencySubStatus[residencySubStatus];
  return fee.defaultAmount;
}

/**
 * Create a payment url for an application.
 */
export function useCreatePaymentUrl() {
  return useMutation({
    mutationKey: ["payment", "url"],
    mutationFn: (applicationId: string) =>
      GetApi(PaymentApi).createPaymentUrl(applicationId),
  });
}
